<!-- components/CategoryModal.vue -->
<template>
  <div v-if="modelValue" class="modal-overlay">
    <div class="modal-content">
      <h5>{{ mode === 'edit' ? currentLang.btnEdit : currentLang.btnAdd }}</h5>
      <input v-model.trim="title" class="form-control" :placeholder="currentLang.placeholderTitle" />
      <div class="mt-3 d-flex gap-2">
        <button class="btn btn-secondary" @click="$emit('update:modelValue', false)">{{currentLang.back }}</button>
        <button class="btn btn-primary" @click="save">{{currentLang.save }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch,computed } from 'vue';
import api from "@/plugins/axios";
import { lang } from "@/plugins/lang";

import enText from "@/locales/en/CategoryModal";
import faText from "@/locales/fa/CategoryModal";

const translations = {
  en: enText,
  fa: faText,
};
const currentLang = computed(() => translations[lang.value]);



const props = defineProps(['modelValue', 'mode', 'targetItem']);
const emit = defineEmits(['update:modelValue', 'refresh']);

const title = ref('');

watch(() => props.targetItem, (newVal) => {
  title.value = props.mode === 'edit' ? newVal?.title : '';
});

const save = async () => {
  if (props.mode === 'edit') {
    await api.patch(`/admin/categories/${props.targetItem.id}`, { title: title.value });
  } else {
    // اگر targetItem داشت یعنی زیرمجموعه است، اگر نه یعنی ریشه
    const parentId = props.targetItem ? props.targetItem.id : null;
    await api.post(`/admin/categories`, { title: title.value, parent_id: parentId });
  }
  emit('refresh');
  emit('update:modelValue', false);
};
</script>


<style scoped>

/* استایل نمونه برای مدال؛ اگر Bootstrap Modal استفاده می‌کنی، می‌تونی این بخش رو حذف کنی */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  background: #fff;
  padding: 1.5rem;
  border-radius: 0.5rem;
  min-width: 320px;
  max-width: 420px;
}

</style>
